<template>
  <v-card class="elevation-5 mb-4 px-2 py-3">
    <v-container fluid grid-list-md class="ma-0 pa-0">
      <v-layout row wrap>
        <v-flex d-flex lg1 xs12>
          <h1
            class="font-weight-black mt-1 primary--text subheading text-xs-center"
          >
            Filtrar:
          </h1>
        </v-flex>
        <v-flex d-flex lg11 xs12>
          <v-layout row wrap>
            <v-flex d-flex lg12>
              <v-layout row wrap>
                <v-flex lg8 xs12>
                  <v-text-field
                    clearable
                    class="mt-0 pt-0"
                    data-cy="numeroProtocolo"
                    label="Nº Protocolo"
                    name="numeroProtocolo"
                    type="text"
                    v-model="filtro.numeroProtocolo"
                    @change="atualizaFiltro"
                    @click:clear="limpaNumeroProtocolo"
                  ></v-text-field>
                </v-flex>
                <v-flex lg2 xs12>
                  <date-picker-default
                    label="Data Inicial"
                    @change="dataInicial"
                    @clear-date="dataInicial"
                  ></date-picker-default>
                </v-flex>
                <v-flex lg2 xs12>
                  <date-picker-default
                    label="Data Final"
                    @change="dataFinal"
                    @clear-date="dataFinal"
                  ></date-picker-default>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex d-flex lg12>
              <v-layout row wrap>
                <v-flex lg4 xs12>
                  <v-select
                    clearable
                    class="mt-0 pt-0"
                    item-text="descricao"
                    item-value="id"
                    label="Tipo de solicitação"
                    v-model="filtro.tipoSolicitacao"
                    @change="atualizaFiltro"
                    :items="dmTipoSolicitacao"
                  ></v-select>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-select
                    clearable
                    class="mt-0 pt-0"
                    item-text="descricao"
                    item-value="id"
                    label="Status do protocolo"
                    v-model="filtro.statusProtocolo"
                    @change="atualizaFiltro"
                    :items="dmStatusProtocolo"
                  ></v-select>
                </v-flex>
                <v-flex lg4 xs12>
                  <v-text-field
                    clearable
                    class="mt-0 pt-0"
                    data-cy="numeroGuia"
                    label="Nº Guia"
                    name="numeroGuia"
                    type="text"
                    v-model="filtro.numeroGuia"
                    @change="atualizaFiltro"
                    @click:clear="limpaNumeroGuia"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import DatePickerDefault from "@/components/DatePickerDefault";

import { listaStatusProtocolo, listaTiposSolicitacao } from "./service";

const portalStore = createNamespacedHelpers("portal");

export default {
  name: "Filtro",
  components: {
    DatePickerDefault
  },
  data() {
    return {
      dmStatusProtocolo: [],
      dmTipoSolicitacao: [],
      filtro: {}
    };
  },
  computed: {
    ...portalStore.mapGetters(["getFiltro"])
  },
  async created() {
    this.filtro = this.getFiltro;
    this.dmStatusProtocolo = await listaStatusProtocolo();
    this.dmTipoSolicitacao = await listaTiposSolicitacao();
  },
  methods: {
    atualizaFiltro() {
      this.$emit("atualizar-grid", this.filtro);
    },
    dataInicial(data) {
      this.filtro = { ...this.filtro, dataInicial: data };

      this.atualizaFiltro();
    },
    dataFinal(data) {
      this.filtro = { ...this.filtro, dataFinal: data };

      this.atualizaFiltro();
    },
    limpaNumeroGuia() {
      this.filtro = { ...this.filtro, numeroGuia: null };
      this.atualizaFiltro();
    },
    limpaNumeroProtocolo() {
      this.filtro = { ...this.filtro, numeroProtocolo: null };
      this.atualizaFiltro();
    }
  }
};
</script>
